const MISSING_RATE_STATUS = new Set(['HOLD_MISSING_CHARGE', 'HOLD_AMBIGUOUS_CHARGE']);

function chargeHeldForMissingRate(item: {
  readiness_status?: string | null;
  hold_reasons?: string[] | null;
}): boolean {
  if (MISSING_RATE_STATUS.has(String(item.readiness_status || ''))) return true;
  return (item.hold_reasons || []).some((reason) =>
    /no charge is selected|not transcribed|no verified submitted-charge|no published|not confirmed/i.test(String(reason))
  );
}

function storedRate(rate: unknown): number | null {
  if (rate === null || rate === undefined || rate === '') return null;
  const parsed = Number(rate);
  return Number.isFinite(parsed) ? parsed : null;
}

/** Billing-console rate subtitle. A held or missing rate is not replaced with $65. */
export function billingRateSubtitle(item: {
  billable_units?: number | null;
  rate?: number | string | null;
  readiness_status?: string | null;
  hold_reasons?: string[] | null;
}): string {
  const units = item.billable_units || 1;
  const rate = storedRate(item.rate);
  if (rate === null || chargeHeldForMissingRate(item)) {
    return `${units} u · rate unavailable`;
  }
  return `${units} u @ $${rate.toFixed(2)}`;
}
